var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"menu-nav"},[_c('li',{staticClass:"menu-item",attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('img',{staticClass:"img-fluid w-125px h-auto ml-n3",attrs:{"src":require('@/assets/images/logo.svg'),"alt":"VDL Hapro"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }